import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Markets } from './components/Markets';
import { Platform } from './components/Platform';
import { Psychology } from './components/Psychology';
import { Benefits } from './components/Benefits';
import { Steps } from './components/Steps';
import { Fomo } from './components/Fomo';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { BottomBar } from './components/BottomBar';
import { track } from './utils/tracking';
const META = {
  title: 'Elyon Markets | Explora Nuevas Oportunidades de Trading',
  description: 'Descubre una experiencia moderna para explorar los mercados financieros y conoce la plataforma de Elyon Markets.',
  keywords: 'trading, forex, mercados financieros, plataforma de trading, Elyon Markets'
};
function useSeoAndTracking(): void {
  React.useEffect(() => {
    document.title = META.title;
    document.documentElement.lang = 'es';
    const setMeta = (key: 'name' | 'property', value: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${key}="${value}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(key, value);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', META.description);
    setMeta('name', 'keywords', META.keywords);
    setMeta('name', 'robots', 'index, follow');
    setMeta('property', 'og:title', META.title);
    setMeta('property', 'og:description', META.description);
    setMeta('property', 'og:type', 'website');
    track('page_view', {
      page: 'landing_elyon_markets'
    });
    track('view_content', {
      content_name: 'landing_elyon_markets'
    });
  }, []);
}
export function App() {
  useSeoAndTracking();
  return <div className="min-h-full w-full bg-white text-ink-900" data-id="element-0" data-mp="36859fxwiety">
      <a href="#mercados" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-xl focus:bg-brand-600 focus:px-4 focus:py-2 focus:text-[13px] focus:font-semibold focus:text-white" data-id="element-1" data-mp="34nbvtnbp1xo">
        Saltar al contenido
      </a>

      <Header data-id="element-2" data-mp="864d5q9pyqes" />

      <main data-id="element-3" data-mp="83i0xdbvvmq8">
        <Hero data-id="element-4" data-mp="3gle7gc7darc0" />
        <TrustBar data-id="element-5" data-mp="3gl4pnbwh7qhe" />
        <Markets data-id="element-6" data-mp="3gkl6xsz04y2b" />
        <Platform data-id="element-7" data-mp="3gm61vjp8aj0p" />
        <Psychology data-id="element-8" data-mp="3gja6a20us6ff" />
        <Benefits data-id="element-9" data-mp="3bmbevr8kqdkx" />
        <Steps data-id="element-10" data-mp="3bmthd5ltxo1a" />
        <Fomo data-id="element-11" data-mp="3bncqbwti5236" />
        <FAQ data-id="element-12" data-mp="3bnmjtudr9rdm" />
        <FinalCTA data-id="element-13" data-mp="3bo4kd37garrc" />
      </main>

      <Footer data-id="element-14" data-mp="3qb7lrkyw9kjy" />
      <BottomBar data-id="element-15" data-mp="3qbpql5zmh73h" />
    </div>;
}